<div #container class="vertical-container">

  <div class="trackable-type-heading" *ngIf="summary">Results by Summary Score Range</div> 
    
  <div class="graph-container">
    <ngx-charts-bar-vertical
    [view]="view"
    [scheme]="colorScheme"
    [results]="data"
    [gradient]="gradient"
    [xAxis]="showXAxis"
    [yAxis]="showYAxis"
    [legend]="showLegend"
    [showXAxisLabel]="showXAxisLabel"
    [showYAxisLabel]="showYAxisLabel"
    [yAxisTickFormatting]="formatTicks"
    [xAxisLabel]="xAxisLabel"
    [yAxisLabel]="yAxisLabel"
    [barPadding]="16"
    (select)="onSelect($event)">
  </ngx-charts-bar-vertical>
  </div> 

</div>